import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/warehouse/reception",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "041"
  ],
  "cita": "Areas/CEDIS/Controllers/WarehouseController.cs"
} satisfies RutaProd;
